import { useMemo } from 'react';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

export const useBannerValidator = (isEditable?: boolean) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredUploadFile('bannerImage'),
                validators.requiredUploadFile('mobileBannerImage'),
                validators.only(() => !isEditable, validators.requiredObjectId('moduleId'))
            ),
        [isEditable]
    );

    return useValidator(validator);
};

export default useBannerValidator;
